import { Component, forwardRef, Inject, OnInit } from "@angular/core";
import { ErrorMessages } from "../../common/constants";
import { Problem } from "../../model";
import { BreadcrumbService } from "../../service/breadcrumb.service";
import { ProblemService } from "../../service/problem.service";
import { ErrorUtility } from "../../utility/error-utility";

@Component({
    selector: 'problem-page',
    template: require('./problem-page.component.html')
})
export class ProblemPageComponent implements OnInit {

    error: string;

    static PROBLEM_LAST_TIMESTAMP_KEY = 'problemLastTimestamp';

    constructor(
        @Inject(forwardRef(() => BreadcrumbService)) private breadcrumbService: BreadcrumbService,
        @Inject(forwardRef(() => ProblemService)) private problemService: ProblemService
    ) { }

    ngOnInit(): void {
        this.refreshBreadcrumb();
        this.updateLocalStorage();
    }

    private refreshBreadcrumb(): void {
        this.breadcrumbService.newBuilder().addProblems().build();
    }

    private updateLocalStorage(): void {
        this.problemService.getPagedList(0, 1, ['startTimestamp', 'desc']).then(page => {
            if (page.content?.length) {
                const problem: Problem = page.content[0];
                localStorage.setItem(ProblemPageComponent.PROBLEM_LAST_TIMESTAMP_KEY, problem.startTimestamp.toString());
            }
        }).catch(err => this.error = ErrorUtility.getMessage(err, ErrorMessages.GET_DATA_ERROR));
    }

}